module.exports = __webpack_public_path__ + "img/corolla-20.955f302c.png";